import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import * as utils from './Utils.js'
import { db } from '../firebase.js';

const Admin = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        // Redirect to login if not signed in
        window.location.href = "/login";
      }
    });

    return () => unsubscribe();
  }, []);

  if (!currentUser) return null; // Don't render until user is authenticated

  return (
    <div className="Admin">
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>Admin</p>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            <a class="btn btn-outline-navyblue" href="/admin/reservations">
              Reservations
            </a>
            <a class="btn btn-outline-navyblue" href="/admin/guests">
              Guests
            </a>
            <a class="btn btn-outline-navyblue" href="/admin/events">
              Events
            </a>
            <a class="btn btn-outline-navyblue" href="/admin/rsvps">
              RSVPs
            </a>
          </div>
        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['black', 'ivory']) }
      </div>
    </div>
  );
};

export default Admin;
